import LeadsService from "@/api/services/leads";

export default {
  namespaced: true,

  state: {
    uniqueToken: "",
    isSubmitting: false,
    isVerifyingCode: false,
    contractualDocuments: {
      advisoryAgreement: "",
      informationNoticeLink: "",
      productInformationSheetLink: "",
    },
  },

  mutations: {
    setUniqueToken(state, token) {
      state.uniqueToken = token;
    },
    setIsSubmitting(state, value) {
      state.isSubmitting = value;
    },
    setIsVerifyingCode(state, value) {
      state.isVerifyingCode = value;
    },
    setContractualDocuments(state, documents) {
      state.contractualDocuments = documents;
    },
    reset(state) {
      state.uniqueToken = "";
      state.isSubmitting = false;
      state.isVerifyingCode = false;
      state.contractualDocuments = {
        advisoryAgreement: "",
        informationNoticeLink: "",
        productInformationSheetLink: "",
      };
    },
  },

  actions: {
    reset({ commit }) {
      commit("reset");
    },

    async create({ commit }, params) {
      commit("setIsSubmitting", true);
      try {
        const response = await LeadsService.create(params);
        if (!response.success) return response;

        const lead = response.data.lead;
        commit("setUniqueToken", lead.estaly_id);
        commit("setContractualDocuments", {
          advisoryAgreement: lead.advisory_agreement || "",
          informationNoticeLink: lead.information_notice_link || "",
          productInformationSheetLink: lead.product_information_sheet_link || "",
        });
        return response;
      } finally {
        commit("setIsSubmitting", false);
      }
    },

    async verifyConsentCode({ state, commit }, consentCode) {
      commit("setIsVerifyingCode", true);
      try {
        const response = await LeadsService.verifyConsentCode(state.uniqueToken, consentCode);
        return response;
      } finally {
        commit("setIsVerifyingCode", false);
      }
    },
  },
};
